<template>
  <router-view/>
</template>

<script>
export default {
  mounted () {
    this.$store.dispatch('Server/live')
  }
}
</script>

<style>
body{
  margin:0;
  padding:0
}
</style>
